import HowItWorks from '../abstract/HowItWorks';

/*
 * Model class FeatureDetails
 */
export default class FeatureDetails extends HowItWorks{
    constructor($sce, content, brandCode, brandColorType, landing_page_images) {
        super($sce, content, brandColorType, brandCode, landing_page_images);

        if (typeof this[brandCode] === 'function') {
            return this[brandCode]();
        }

        return this.general();
    }

    general() {
        return this.feature();
    }

    ea_gma_ch() {
        let features = this.feature();

        features.id_monitoring.icon = `<svg class="flag-icon"><use xlink:href="#globe-2" /></svg>`;
        features.pc_laptop.icon = `<svg class="flag-icon"><use xlink:href="#laptop-2" /></svg>`;
        features.mobile_protection.icon = `<svg class="flag-icon"><use xlink:href="#mobile" /></svg>`;
        features.assistance.icon = `<svg class="flag-icon"><use xlink:href="#assistance" /></svg>`;

        for (let index in features) {
            features[index].description.icon = `<svg class="flag-icon"><use xlink:href="#tick" /></svg>`;
        }

        return features;
    }
}